'use client';
import { sortLabelName } from 'components/associated-dealers/utils';
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { dealerAssociationAction } from 'services/request-service/action';
import { RequestEquipmentServiceProviderProps } from './types';

const RequestServiceContext = createContext(null);
export const useRequestEquipmentService = () =>
  useContext(RequestServiceContext);

export const RequestEquipmentServiceProvider = ({
  isLoggedIn,
  children,
  serviceInsights
}: RequestEquipmentServiceProviderProps) => {
  const [isRSModalOpen, setIsRSModalOpen] = useState(false);
  const [equipmentInfo, setEquipmentInfo] = useState([]);
  const [dealerAssociation, setDealerAssociation] = useState([]);

  const getDealerAssociation = async () => {
    const response = await dealerAssociationAction();
    const dealerList = response?.associations
      ?.map((association) => {
        return {
          label: association.dealerName,
          value: association.id,
          isDefault: association.isDefault
        };
      })
      .sort(sortLabelName);
    setDealerAssociation(dealerList);
  };

  useEffect(() => {
    if (isLoggedIn) {
      getDealerAssociation();
    }
  }, [isLoggedIn]);

  const contextValue = useMemo(
    () => ({
      isRSModalOpen,
      setIsRSModalOpen,
      equipmentInfo,
      setEquipmentInfo,
      dealerAssociation,
      serviceInsights
    }),
    [equipmentInfo, isRSModalOpen, dealerAssociation, serviceInsights]
  );

  return (
    <RequestServiceContext.Provider value={contextValue}>
      {children}
    </RequestServiceContext.Provider>
  );
};
